import React from 'react';
import { translations } from '../translations';
import WaitlistForm from './WaitlistForm';
import { Zap, Bell, Gift } from 'lucide-react';

const WaitlistSection = ({ language = 'en' }) => {
  const t = translations[language].comingSoon;

  return (
    <section className="py-24 bg-gradient-to-br from-[#3498DB]/5 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Benefits */}
          <div>
            <h2 className="text-4xl font-bold text-[#2c3e50] mb-6">
              {t.waitlistTitle}
            </h2>
            <p className="text-xl text-gray-600 mb-12">
              {t.waitlistDescription}
            </p>
            
            <div className="space-y-8">
              {[
                {
                  icon: Zap,
                  title: t.waitlist.benefits.earlyAccess.title,
                  description: t.waitlist.benefits.earlyAccess.description
                },
                {
                  icon: Bell,
                  title: t.waitlist.benefits.exclusiveUpdates.title,
                  description: t.waitlist.benefits.exclusiveUpdates.description
                },
                {
                  icon: Gift,
                  title: t.waitlist.benefits.specialOffers.title,
                  description: t.waitlist.benefits.specialOffers.description
                }
              ].map((benefit, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-lg bg-[#3498DB]/10 flex items-center justify-center flex-shrink-0">
                    <benefit.icon className="w-6 h-6 text-[#3498DB]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-[#2c3e50] mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="lg:pl-12">
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#2c3e50] mb-4">
                {t.waitlist.subtitle}
              </h3>
              <WaitlistForm language={language} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WaitlistSection; 